import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { Constants } from '@shared/constants/constants';

@Component({
  selector: 'app-reject-service-request',
  templateUrl: './reject-service-request.component.html',
  styleUrls: ['./reject-service-request.component.scss']
})
export class RejectServiceRequest extends DialogBase implements OnInit {
  type: any;
  title: any;
  reasons: any[];
  submitBtn: any;
  initInfo: any;
  cdData: any;
  data: any;

  comment: any;
  reason: any;
  reasonOptions: any[] = [];

  ngOnInit(): void {
    this.apiService.master.getStatus(Constants.detailType.REPAIR.code)
    this.spinnerService.start();
    this.apiService.master.getStatus(Constants.detailType.REPAIR.code)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        const status = res['E0003'];
        const reasons: any = [];

        Object.keys(status.reason).forEach(key => {
          if (key !== 'AAAA') {
            const reason = {
              code: key,
              name: `[${ key }] ${ status.reason[key].name }`,
            }
            reasons.push(reason);
          }
        });
        this.reasonOptions = reasons;
      }, err => Utils.showError(err));
  }

  reject() {
    if (!this.reason || !this.comment) {
      return;
    }
    this.onClose.next({
      confirm: true,
      reason: this.reason,
      comment: this.comment,
    });
    this.bsModalRef.hide();
  }
}
